<app-empty-table *ngIf="!items?.length" class="container-box">
  <img class="empty-image" src="assets/images/empty_icons/message-draft-task.svg" />
  <h5 class="empty-header" i18n>No Message based Incidents yet for Task Approval</h5>
  <p i18n>
    AI hasn't found any guest messages. When issues come up, they'll appear here with suggestion for quick review.
  </p>
</app-empty-table>

<ng-container *ngFor="let item of items">
  <div class="container-box d-flex gap-3 p-3">
    <app-rental-image [rentalId]="item.incident.rental_id" [circle]="true" [size]="50"></app-rental-image>
    <div class="flex-fill">
      <ul class="dot-segments-list">
        <li class="text-bold">
          <app-rental-name [rentalId]="item.incident.rental_id"></app-rental-name>
        </li>
        <li class="text-light">
          {{ item.message.created | epoch : 'datetime' }}
        </li>
        <li class="text-light">
          {{ item.message.name || item.message.from }}
        </li>
      </ul>

      <div class="bg-default p-2 rounded mt-2">
        <div [innerHtml]="item.sanitizedMessageHtml || item.message.messageTxt"></div>
      </div>
    </div>
  </div>
  <div class="d-flex flex-wrap align-items-center gap-3 mt-2 mb-3">
    <div class="text-warning bg-secondary-warning px-2 py-1 rounded">
      AI has created an <a href="javascript:;" (click)="onIncident(item.incident)">incident</a>.
      <ng-container i18n *ngIf="item.task.draft">Approve to generate a task from it.</ng-container>
      <ng-container i18n *ngIf="!item.task.draft">A task has been generated from it.</ng-container>
    </div>
    <div class="flex-fill"></div>
    <button class="btn btn-secondary-info btn-sm" (click)="onViewTask(item.task)" *ngIf="!item.task.draft">
      <i class="cs-icon cs-icon-eye"></i>
      <ng-container i18n>View Task</ng-container>
    </button>
    <ng-container *ngIf="item.task.draft">
      <button class="btn btn-secondary-danger btn-sm" (click)="onRejectTask(item.task)">
        <i class="cs-icon cs-icon-times"></i>
        <ng-container i18n>Reject</ng-container>
      </button>
      <button class="btn btn-secondary-success btn-sm" (click)="onApproveTask(item.task)">
        <i class="cs-icon cs-icon-check"></i>
        <ng-container i18n>Approve & Create Task</ng-container>
      </button>
    </ng-container>
  </div>
</ng-container>
